import { Menu, X, User, MapPin, ChevronDown, ChevronRight, Languages, Check, ShieldCheck } from "lucide-react";
import React, { useEffect, useState } from "react";
import { categories } from "../../utils/Customer/CustomerData";
import { ImagePath } from "../../assests";
import HeaderButtons from "../../components/customer/HeaderButtons";
import { Navigate, useLocation, useNavigate } from "react-router-dom";

const CheckoutHeader: React.FC = () => {
    const navigation = useNavigate()
    const [menuOpen, setMenuOpen] = useState(false);
    const [openCategory, setOpenCategory] = useState<string | null>(null);
    const [openGroup, setOpenGroup] = useState<string | null>(null);
    const location = useLocation();

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth >= 1024) {
                setMenuOpen(false);
            }
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    // Explicitly determine route indices
    const getCurrentStepIndex = () => {
        if (location.pathname.includes("customercartpage")) return 0;
        if (location.pathname.includes("customeraddresspage")) return 1;
        if (location.pathname.includes("customerpaymentpage")) return 2;
                if (location.pathname.includes("CustomerPaymentSuccessScreen")) return 2;
        return -1; // Return -1 if it's not a standard checkout flow route
    };

    const currentStepIndex = getCurrentStepIndex();
    const isPaymentPage = currentStepIndex === 2;
    
    // Check if we should render the checkout stepper steps at all
    const showCheckoutSteps = currentStepIndex !== -1;

    // Build the structural data representation for each stage
    const steps = [
        { id: "cart", label: "Cart" },
        { id: "checkout", label: "Checkout" },
        { id: "payment", label: "Payment" }
    ];

    return (
        <>
            {/* ================= HEADER ================= */}
            <div className="w-full h-[60px] flex items-center justify-between bg-logoHeading px-3 md:px-4 lg:px-6 select-none">

                {/* LEFT: LOGO SECTION */}
                <div className="flex items-center gap-3 shrink-0">
                    <img
                        src={ImagePath.Logo}
                        className="h-6 lg:h-8 object-contain"
                        alt="logo"
                        onClick={()=> navigation('/')}
                    />
                </div>

                {/* CENTER: COHESIVE STEPPER PIPELINE (Only shows if on a checkout page) */}
                <div className="hidden md:flex items-center gap-6 lg:gap-8 mx-auto">
                    {showCheckoutSteps && steps.map((step, index) => {
                        let isCompleted = false;
                        let isActive = false;

                        if (step.id === "cart") {
                            isCompleted = true;
                        } else if (step.id === "checkout") {
                            isActive = currentStepIndex === 0 || currentStepIndex === 1;
                            isCompleted = currentStepIndex === 2;
                        } else if (step.id === "payment") {
                            isActive = currentStepIndex === 2;
                        }

                        return (
                            <div key={step.id} className="flex items-center gap-6 lg:gap-8">
                                <div className="flex items-center gap-2">
                                    {/* Indicator Circle Badge Layout */}
                                    <div 
                                        className={`w-5 h-5 rounded-full flex items-center justify-center text-[10px] font-black tracking-tighter transition-all duration-300 ${
                                            isCompleted 
                                                ? "bg-emerald-500 text-white" 
                                                : isActive 
                                                    ? "bg-white text-logoHeading ring-4 ring-white/20" 
                                                    : "bg-white/20 text-white/60"
                                        }`}
                                    >
                                        {isCompleted ? <Check size={11} className="stroke-[3.5]" /> : index + 1}
                                    </div>
                                    
                                    {/* Label Text */}
                                    <span 
                                        className={`text-xs font-black tracking-wide uppercase transition-colors duration-300 ${
                                            isActive || isCompleted ? "text-white" : "text-white/40"
                                        }`}
                                    >
                                        {step.label}
                                    </span>
                                </div>

                                {/* Intermediate Divider line connector */}
                                {index < steps.length - 1 && (
                                    <div 
                                        className={`h-[1px] w-8 lg:w-12 transition-colors duration-300 ${
                                            currentStepIndex >= index ? "bg-emerald-500" : "bg-white/20"
                                        }`} 
                                    />
                                )}
                            </div>
                        );
                    })}
                </div>

                {/* RIGHT: SECURE TRUST BADGE */}
                <div className="flex items-center justify-end shrink-0 min-w-[140px]">
                    {isPaymentPage ? (
                        <div className="flex items-center gap-1.5 bg-emerald-500/10 border border-emerald-500/20 px-3 py-1.5 rounded-xl animate-in fade-in zoom-in-95 duration-300">
                            <ShieldCheck size={14} className="text-white stroke-[2.5]" />
                            <span className="text-[10px] font-black text-white uppercase tracking-wider">
                                100% Secure Payment
                            </span>
                        </div>
                    ) : (
                        <div className="w-4 h-4" />
                    )}
                </div>
            </div>

            {/* ================= MOBILE DRAWER ================= */}
       
        </>
    );
};

export default CheckoutHeader;